import React, { Component } from 'react';
import Relay from 'react-relay/classic';
import { Divider } from '@lyearn-team/frontend-components';
import themeConfig from '@lyearn-team/theme-config';
import './index.css';
import Section from './Section';
import AssignmentDetails from './AssignmentDetails';
import CourseOverview from './CourseOverview';

class CourseDetails extends Component {
  renderAssignmentDetails = course => {
    // console.log('course1: ', course);
    if (course.assignInfo) {
      return (
        <Section title="Assignment Details">
          <AssignmentDetails course={course} />
        </Section>
      );
    }
    return null;
  };

  render() {
    const course = this.props.rootQ;
    return (
      <div className="CourseDetailsContainer">
        {this.renderAssignmentDetails(course)}
        <Divider style={{ background: themeConfig.color.dark.venus }} />
        <Section title="Overview">
          <CourseOverview course={course} />
        </Section>
        <Divider style={{ background: themeConfig.color.dark.venus }} />
      </div>
    );
  }
}

export default Relay.createContainer(CourseDetails, {
  initialVariables: {},
  fragments: {
    rootQ: () => Relay.QL`
      fragment on Course {
        id
        pid
        name
        description
        duration
        teachers {
          pid
          name
          picture
        }
        assignInfo {
          dueDate
          assignedDate
          assignedBy {
            pid
          }
        }
      }
    `
  }
});
